export default "__VITE_ASSET__Fq1wZN53__"